import React, { useState } from 'react';
import { ComplianceGrouper } from './ManageCompliance/ComplianceGrouper';
import { ComplianceTable } from './ManageCompliance/ComplianceTable';
import { LayoutGridItem } from 'app/layout/LayoutGrid';
import { useSelector } from 'react-redux';
import { selectCredOneDetails } from 'store/redux-store/placement-details/selectors';
import { setupRequirementsData } from './ManageCompliance/helper';
import { cloneDeep } from 'lodash';

export const ComplianceDetails = () => {
  const credOneDetails = useSelector(selectCredOneDetails);
  const requirements = cloneDeep(credOneDetails ? setupRequirementsData(credOneDetails) : []);
  const requirementsLayer = useState(requirements);

  const handleComplianceFilter = (filterType: number | string) => {
    requirements.filter(requirementItem => requirementItem.requirementStatusType === filterType);
  };

  return (
    <LayoutGridItem container direction="column" rowGap={2} pl="12px">
      <LayoutGridItem item>
        <ComplianceGrouper handleComplianceFilter={filterType => handleComplianceFilter(filterType)} />
      </LayoutGridItem>
      <LayoutGridItem item>
        <ComplianceTable requirementsLayer={requirementsLayer} />
      </LayoutGridItem>
    </LayoutGridItem>
  );
};
